.devider {
  width: 100%;
  border: none;
  box-sizing: border-box;
  height: 1px;
  margin-top: 0;
  margin-bottom: 0;

  @include themify($themes) {
    background: themed("neutral-secondary");
  }
}

.deviderContainer {
  width: 100%;
  box-sizing: border-box;
}